import React, { useMemo } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';
import { getLogger } from '../../adapters/get-logger';

// important! do not change the name for each page since they are used in our report
export const PageNameForLog = {
  Landing: 'LandingPage',
  Performance: 'PerformancePage',
  Images: 'ImagesPage',
  DisplayTemplates: 'DisplayTemplatesPage',
  Videos: 'VideosPage',
  EditVideoPage: 'EditVideosPage',
  VideoTemplates: 'VideoTemplatesPage',
  BrandKit: 'BrandKitPage',
  Library: 'LibraryPage',
  CreateDisplayTemplate: 'CreateDisplayTemplatePage',
  EditDisplayTemplate: 'EditDisplayTemplatePage',
  WebsiteImagePanel: 'WebsiteImagePanel',
  StockImagePanel: 'StockImagePanel',
  InvestImagePanel: 'InvestImagePanel',
  InvestVideoPanel: 'InvestVideoPanel',
  AddVideoPanel: 'AddVideoPanel',
  SearchResultPage: 'SearchResultPage',
  GenerateImagePage: 'GenerateImagePage',
  UploadFilesPanelPage: 'UploadFilesPanelPage',
  UploadFolderPanelPage: 'UploadFolderPanelPage',
  MixedImagePanelPage: 'MixedImagePanelPage',
  MixedVideoPanelPage: 'MixedVideoPanelPage',
  EditImagePage: 'EditImagePage',
  EditImageTab: 'EditImageTab',
  AssetDetailsPage: 'AssetDetailsPage',
  BackgroundRemovalModalPage: 'BackgroundRemovalModalPage',
};

export const VersionForLog = {
  AdsStudioMVP: 'ads-studio-mvp',
};

export function withCustomLogForPage(WrappedComponent, { pageName, tag = 'Ads studio' }) {
  const Wrapper = (props) => {
    const { activity } = props || {};
    const version = VersionForLog.AdsStudioMVP; // todo: get version from permissions

    const logger = useMemo(() => getLogger(activity, pageName, version, tag), [activity, version]);

    return <WrappedComponent {...props} logger={logger} />;
  };

  Wrapper.displayName = `withCustomLog(${getDisplayName(WrappedComponent)})`;
  hoistNonReactStatics(Wrapper, WrappedComponent);

  return Wrapper;
}

export const getLoggerWithoutPageInfo = (activity, version, tag = 'Ads studio') => getLogger(activity, '', version, tag);

// need update this function before starting new pilot
export const getLogVersion = () => VersionForLog.AdsStudioMVP;
